import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './TopProgressBar.scss';

const TopProgressBar: React.FC = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const prevPath = useRef(location.pathname);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (prevPath.current === location.pathname) return;
    prevPath.current = location.pathname;

    if (timerRef.current) clearTimeout(timerRef.current);
    setVisible(true);

    // Keep bar visible long enough for lazy chunks + initial API calls to settle.
    // The bar animates indefinitely via CSS — this just controls unmount timing.
    timerRef.current = setTimeout(() => setVisible(false), 3000);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [location.pathname]);

  if (!visible) return null;
  return <div className="top-progress-bar" aria-hidden="true" />;
};

export default TopProgressBar;
